import { ColumnDef } from "@tanstack/react-table"

import type { MeterSizeType } from "@/types/meter"

import { DataTableColumnHeader } from "../../data-table"
import { MeterSizeOperation } from "../operations/meter-size-operations"

export const meterSizeColumns: ColumnDef<MeterSizeType>[] = [
  {
    accessorKey: "id",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="ID" />
    ),
    cell: ({ row }) => {
      const value = row.original.id
      return <div>{value}</div>
    },
  },
/*   {
    accessorKey: "connection_type",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Connection Type" />
    ),
    cell: ({ row }) => {
      const value = row.original.connection_type
      return <div>{value}</div>
    },
  }, */
  {
    accessorKey: "description",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Description" />
    ),
    cell: ({ row }) => {
      const value = row.original.description
      return <div>{value}</div>
    },
  },
  {
    accessorKey: "size",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Size" />
    ),
    cell: ({ row }) => {
      const value = row.original.size
      return <div>{value}</div>
    },
  },
  {
    accessorKey: "actions",
    header: () => {
      return <div className="text-center dark:text-white">Actions</div>
    },
    cell: ({ row }) => {
      return (
        <div className="px-4 py-2 text-center md:py-0 md:text-center">
          <MeterSizeOperation data={row.original} />
        </div>
      )
    },
  },
]
